import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { POST, POSTBody } from "~utils";

/**
 * Custom hook for submitting timesheet entries via POST
 * @param intervalId - The interval ID for the timesheet
 * @returns Mutation result with proper typing
 */
export function useTimesheetSubmission(intervalId: string) {
  return useMutation<void, AxiosError, POSTBody<"/api/sub/timesheet/{interval-id}">>({
    mutationFn: (payload: POSTBody<"/api/sub/timesheet/{interval-id}">) => {
      return POST("/api/sub/timesheet/{interval-id}", payload, {
        pathParams: { "interval-id": intervalId },
      });
    },
  });
}
